import * as React from 'react';
import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import {
    OverlayContainer,
    CloseButton,
    AutoScrollbars
} from 'components';
import { IState } from 'services/root-reducer';
import { getOperationSafe } from 'selectors';
import {
    actions as overlayWindowsActions,
    GenericOverlayOperation
} from 'services/overlay-windows/overlay-windows-service';
import { actions as appActions } from 'services/app/app-service';
import { LoginForm } from './login-form';

import './style.scss';

export interface IOverlayLoginProps extends WithTranslation {
    loginOverlay: GenericOverlayOperation;
    forceShow?: boolean;
}
export interface IOverlayLoginState {}

const mapStateToProps = (state: IState) => ({
    loginOverlay: getOperationSafe(state, 'LOGIN_OVERLAY')
});

class OverlayLoginComponent extends React.Component<IOverlayLoginProps, IOverlayLoginState> {
    constructor(props: IOverlayLoginProps) {
        super(props);

        this.onCloseClick = this.onCloseClick.bind(this);
    }

    onCloseClick() {
        appActions.resetLoginOperation();
        overlayWindowsActions.hideLoginOverlay();
    }

    render() {
        let {
            loginOverlay,
            forceShow = false,
            t
        } = this.props;

        if (!forceShow && !loginOverlay.data?.visible) {
            return null;
        }

        return (
            <OverlayContainer
                className='login-form-overlay'
                containerClassname='form-wrapper'
                backgroundOpacity={8}
            >
                {!forceShow && (
                    <CloseButton onClick={this.onCloseClick} />
                )}

                <div className="form">
                    <AutoScrollbars className='padding-fix'>
                        <div className="form-header">
                            {t('Вход')}
                        </div>
                        <div className="form-body">
                            <LoginForm />
                        </div>
                    </AutoScrollbars>
                </div>
            </OverlayContainer>
        );
    }
}

export const OverlayLogin = connect(mapStateToProps)(withTranslation()(OverlayLoginComponent));
